import { render, staticRenderFns } from "./ProdutosBuscar.vue?vue&type=template&id=6d0e7610&scoped=true&"
import script from "./ProdutosBuscar.vue?vue&type=script&lang=js&"
export * from "./ProdutosBuscar.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosBuscar.vue?vue&type=style&index=0&id=6d0e7610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0e7610",
  null
  
)

export default component.exports